import React from 'react'
import Nav from '../../components/common/header'
import Footer from '../../components/common/footer'
import { useEffect } from 'react';
import { useState } from 'react';

export default ({ children }) => {

    const [getLinearProgressBar, setLinearProgressBar] = useState(false);

    useEffect(() => {
        setLinearProgressBar(false);
    }, [])

    var divStyle = {
        display: getLinearProgressBar ? 'block' : 'none'
    };


    return (
        <div>
            <Nav />
            <div id="loadingProgressG" style={divStyle}>
                <div id="loadingProgressG_1" class="loadingProgressG"></div>
            </div>
            <div class='header2'><span>Welcome&nbsp;</span><span id='spanuserlogged'></span></div>
            <main className='d-flex flex-column min-vh-100'> {children}</main>
            <Footer />
        </div>
    )
}

